export default __webpack_public_path__ + "static/media/twitter.a32f54f8.png";